import { AmmoPhysics } from "@enable3d/ammo-physics";
import { Object3D } from "three";
import { StateCreator } from "zustand";

export const createAppSlice: StateCreator<
  AppSlice,
  [["zustand/subscribeWithSelector", never]],
  []
> = (set, get) => ({
  askPermissions: false,
  setAskPermissions: (ask: boolean) => {
    set({ askPermissions: ask });
  },
  tapToPlace: false,
  setTapToPlace(tap) {
    set({ tapToPlace: tap });
  },
  setSelectedObject: (object: Object3D | undefined) => {
    set({ selectedObject: object });
  },
  physics: undefined,
  setPhysics: (physics: AmmoPhysics | undefined) => {
    set({ physics: physics });
  },
});

export interface AppSlice {
  askPermissions: boolean;
  setAskPermissions: (askPermissions: boolean) => void;
  tapToPlace: boolean;
  setTapToPlace: (tap: boolean) => void;
  selectedObject?: Object3D | undefined;
  setSelectedObject: (object: Object3D | undefined) => void;
  physics?: AmmoPhysics;
  setPhysics: (physics: AmmoPhysics) => void;
}
